import {Component, OnInit, Output, Injectable, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {GlobalDataService} from '../services/global-data.service';
import {EmitterService} from '../services/emitter.service';
import {User, ForgotPassword, FirstTimePasswordObj} from '../models/data-model';
import {GlobalVariable} from '../../../../app/config';
import {Headers, Http} from '@angular/http';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/timer';
import 'rxjs/add/observable/interval';
import "rxjs/add/operator/finally";
import "rxjs/add/operator/takeUntil";
import "rxjs/add/operator/map";
import * as moment from 'moment';

@Component({
  selector: 'app-login',
  templateUrl: '../views/login.component.html',
  styleUrls: ['../css/login.component.css'],

})
@Injectable()
export class LoginComponent implements OnInit {
  public loginForm: any;
  public submitted = false;
  public user = new User('', '', new Date());
  public firsttimepassword = new FirstTimePasswordObj('', '', {}, '', new Date(), '');
  public errorMessage = "";
  public showheader = 0;
  public login_page: boolean = true;
  public new_password: boolean = false;
  public timezonelist: any;
  public showpasswordvalid: boolean = false;
  public apiendpoint_url = GlobalVariable.FORDAPIEndPointURL;
  public subscriptions: Array<Subscription> = [];
  public validatefirstpassword: boolean = false;
  public checklength: boolean = false;
  public checkcaptial: boolean = false;
  public checknumber: boolean = false;
  public password_submitted: boolean = false;
  private subscription: Subscription;
  private timer: Observable<any>;
  public login_error: boolean = false;
  public countdown: number;
  public isEmailValid: boolean = false;
  public showIcon: boolean = false;
  public spinnerIcon: boolean = false;
  public redirectionURL: string;
  public redirectUrlString: string;

  constructor(private _dataService: GlobalDataService, private _emitterService: EmitterService,
              private _router: Router, private http: Http, private _route: ActivatedRoute) {
    this.redirectUrlString = _route.snapshot.params["redirectURL"];
  }

  ngOnInit() {
    const userObj = sessionStorage.getItem("user");
    const path = this._dataService.getPreviousUrl();
    sessionStorage.clear();
    localStorage.clear();
    this.validateEmail("NoEvent");
    this.redirectionURL = this._dataService.redirectUrl || 'dashboard'
  }

  /**
   * @author Ciocan Vlad
   * @uses   User Authentication
   */

  login() {
    const thisObj = this;
    this._emitterService.setSpinner(true);
    thisObj.errorMessage = '';
    sessionStorage.setItem('email', thisObj.user.username);
    this.http.post(this.apiendpoint_url + '/user/login', thisObj.user)
      .subscribe(
        (data) => {
          this._emitterService.setSpinner(false);
          const res = data.json();//For Success Response
          if (res.statusCode != null) {
            if (res.statusCode == 205) {
              this.login_page = false;
              this.new_password = true;
              thisObj.errorMessage = '';
              this.getTimezonelist();
              sessionStorage.setItem('userId', res.response.userId);
              sessionStorage.setItem('username', res.response.username);

              //If we set the session for user,  it  redirects to  dashboard  when  we press back button  from first time login page
              if (res.response.timezone != null) {
                this.firsttimepassword.timezone.id = res.response.timezone.id;
              }
            } else if (res.statusCode == 200) {
              this._emitterService.setloadHeader(true);
              thisObj.errorMessage = '';
              localStorage.setItem("token", res.token);
              localStorage.setItem("uuid", res.userUUID);
              localStorage.setItem("user", JSON.stringify(res.response));
              localStorage.setItem('userId', res.response.userId);
              localStorage.setItem('roleId', res.response.roleId.code);
              localStorage.setItem('expirytime', res.tokenExpiredTime);
              sessionStorage.setItem('pageLimit', res.response.pageLimit);
              sessionStorage.setItem("token", res.token);
              sessionStorage.setItem("uuid", res.userUUID);
              sessionStorage.setItem("user", JSON.stringify(res.response));
              sessionStorage.setItem('userId', res.response.userId);
              sessionStorage.setItem('roleId', res.response.roleId.code);
              sessionStorage.setItem('expirytime', res.tokenExpiredTime);
              if (res.response.timezone != null) {
                this._dataService.getUserTimeZone();
              }
              //let params = this._route.snapshot.queryParams.get('redirectURL');
              if (this.redirectUrlString) {
                this.redirectionURL = this.redirectUrlString;
              }
              this._router.navigate([this.redirectionURL]);
              if (sessionStorage.getItem('roleId') == 'ADHVDR') {
                this._router.navigate(['/leads/adhoc']);
              }
            } else if (res.statusCode == 400) {
              //localStorage.clear();
              sessionStorage.clear();
              thisObj.errorMessage = "Password is incorrect";
              //this.setErrordivTime()
            } else if (res.statusCode == 423) {
              sessionStorage.clear();
              if (res.httpStatus == 'LOCKED' && res.response.active != null && !res.response.active) {
                thisObj.errorMessage = "Your login has been disabled.";
              } else if (res.httpStatus == 'LOCKED' && res.response.authFailCount >= 5) {
                thisObj.errorMessage = "You’ve reached the max number of login attempts and your account has been locked. Please try again after 30 minutes.";
              } else if (res.httpStatus == 'LOCKED' && res.response.deleteUser) {
                thisObj.errorMessage = "Invalid credentials.";
              }
            } else {
              thisObj.errorMessage = "Invalid credentials.";
            }
          } else {
            thisObj.errorMessage = "Invalid credentials.";
          }

        },
        err => {
          this._emitterService.setSpinner(false);
          this._emitterService.setloadHeader(false);
          sessionStorage.clear();
         var data=err.json();
         //console.log(data);
          thisObj.errorMessage = data.message;
          thisObj._router.navigate(['login']);
        }
      );
  }

  startCountdownTimer() {
    let expirytime = sessionStorage.getItem("expirytime");

    let now = moment(expirytime, "x").format('YYYY-MM-DD HH:mm:ss');
    let end = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    let end_date = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
    let durationm = moment.duration(end_date.diff(now));
    let minutes = durationm.asMinutes();
    let interval = Math.abs(minutes) * 60000;
    const duration = 10 * 1000;
    const stream$ = Observable.timer(0, interval)
      .finally(() => {
        this._dataService.refreshToken();
        this.startCountdownTimer()
      })
      .takeUntil(Observable.timer(duration + interval))
      .map(value => duration - value * interval);
    stream$.subscribe(value => {
      this.countdown = value;
    });


  }

  /**
   * @author Ciocan Vlad
   * @uses   Update password for First time login
   */

  savepassword() {
    let thisObj = this;
    this.firsttimepassword.userId = sessionStorage.getItem('userId');
    this.firsttimepassword.username = sessionStorage.getItem('username');
    this.firsttimepassword.lastlogintime = new Date();
    this._dataService.PostAjaxCall(this.apiendpoint_url + "/user/update", this.firsttimepassword, (result) => {
      if (result.statusCode == 200) {
        this._emitterService.setloadHeader(true);
        thisObj.errorMessage = '';
        localStorage.setItem("token", result.token);
        localStorage.setItem("uuid", result.userUUID);
        localStorage.setItem("user", JSON.stringify(result.response));
        localStorage.setItem('userId', result.response.userId);
        localStorage.setItem("role", JSON.stringify(result.response.roleId));
        localStorage.setItem('expirytime', result.tokenExpiredTime);

        sessionStorage.setItem("token", result.token);
        sessionStorage.setItem("uuid", result.userUUID);
        sessionStorage.setItem("user", JSON.stringify(result.response));
        sessionStorage.setItem('userId', result.response.userId);
        sessionStorage.setItem("role", JSON.stringify(result.response.roleId));
        sessionStorage.setItem('expirytime', result.tokenExpiredTime);


        this._router.navigate(['dashboard']);
      } else {
        sessionStorage.clear();
        this.login_page = false;
        this.new_password = true;
        this._emitterService.setloadHeader(false);
        thisObj.errorMessage = "Invalid details. Please udpate again !!"
      }
    })
  }

  /**
   * @author Ciocan Vlad
   * @uses get the timezone list
   */
  getTimezonelist() {
    this._dataService.GetAjaxCall(this.apiendpoint_url + '/user/timezone/list', (result) => {
      this.timezonelist = result;
    });
  }

  validatepassword() {
    this.showpasswordvalid = this.firsttimepassword.password != "";
    this.checkcaptial = false;
    this.checknumber = false;
    this.checklength = false;
    this.validatefirstpassword = false;
    if (this.firsttimepassword.password.match(/.*[A-Z].*/))
      this.checkcaptial = true;
    if (this.firsttimepassword.password.match(/.*\d.*/))
      this.checknumber = true;
    if (this.firsttimepassword.password.length >= 8)
      this.checklength = true;
    if (this.checklength && this.checknumber && this.checkcaptial)
      this.validatefirstpassword = true;
  }

  setErrordivTime() {
    this.login_error = true;

    this.timer = Observable.timer(5000); // 5000 millisecond means 5 seconds
    this.subscription = this.timer.subscribe(() => {
      // set showloader to false to hide loading div from view after 5 seconds
      this.login_error = false;
    });
  }

  /**
   * @author Sowmya
   * validate email
   */
  validateEmail(e) {
    const username = this.user.username;
    if (username != '') {
      this.spinnerIcon = true;
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.isEmailValid = pattern.test(username);
      if (e != 'NoEvent' && e.type != 'undefined' && e.type == 'keyup') {
        this.spinnerIcon = true;
        if (this.isEmailValid) {
          this.showIcon = true;
          this.spinnerIcon = false;
        }
      } else {
        this.showIcon = true;
        this.spinnerIcon = false;
      }
    } else {
      this.showIcon = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/login.component.ts